'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fp = require('lodash/fp');

/**
 * Ensures a value lies within a range.
 */
exports.default = (0, _fp.curry)(function (rangeStart, rangeMax, value) {
  return Math.max(Math.min(value, rangeMax), rangeStart);
}); // Lib


//////////////////
// WEBPACK FOOTER
// ./src/common/maths/clamp.js
// module id = 2276
// module chunks = 0